import * as yup from 'yup';

export const notificationScheduleSchema = yup.object({
  scheduleDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === '' || originalValue === undefined) return null;
      return originalValue instanceof Date ? originalValue : new Date(originalValue);
    })
    .typeError('Fecha de inicio no es válida')
    .required('Fecha de inicio es requerida')  
});